var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
var ShippingAlt20 = function (_a) {
    var _b = _a.color, color = _b === void 0 ? 'currentcolor' : _b, _c = _a.height, height = _c === void 0 ? '20px' : _c, _d = _a.width, width = _d === void 0 ? '20px' : _d, rest = __rest(_a, ["color", "height", "width"]);
    var svgStyle = __assign({ "position": "absolute", "top": "0", "right": "0", "bottom": "0", "left": "0", "width": "100%", "height": "100%" }, { fill: color });
    return (React.createElement("div", __assign({ style: __assign({ "position": "relative" }, { height: height, width: width }) }, rest),
        React.createElement("svg", { viewBox: "0 0 20 20", xmlnsXlink: "http://www.w3.org/1999/xlink", style: svgStyle },
            React.createElement("desc", null, "Created with Sketch."),
            React.createElement("g", { id: "Shipping_Alt_20_svg__Icons/Shipping-Box/20", stroke: "none", strokeWidth: 1, fillRule: "evenodd" },
                React.createElement("path", { d: "M10,4 L19,7 L19,14 L10,17 L1,14 L1,7 L10,4 Z M2,8.38742589 L2,13.2792408 L9.5,15.778 L9.5,10.887 L2,8.38742589 Z M18,8.38742589 L10.5,10.887 L10.5,15.778 L18,13.2792408 L18,8.38742589 Z M14.357,6.506 L7.127,9.042 L10,10 L17.42,7.527 L14.357,6.506 Z M10,5.05409255 L2.58,7.527 L5.665,8.555 L12.895,6.019 L10,5.05409255 Z", id: "Shipping_Alt_20_svg__Combined-Shape", fillRule: "nonzero" })))));
};
ShippingAlt20.displayName = 'ShippingAlt20';
export default ShippingAlt20;
//# sourceMappingURL=shipping-alt-20.js.map